import React, { FC, useState } from 'react'

import { EuiSpacer } from '@elastic/eui'

import { Persona } from 'api/entities/Persona'

import PersonaCard from './PersonaCard'

export interface PersonaListProps {
  personas: Persona[]
}

const PersonaList: FC<PersonaListProps> = ({ personas }) => {
  const sortedPersonas = [...personas].sort((a, b) => a.rank - b.rank)
  const [expandedPersonas, setExpandedPersonas] = useState<Set<number>>(new Set(sortedPersonas.map(persona => persona.rank)))

  const togglePersona = (rank: number) => {
    const newExpanded = new Set(expandedPersonas)
    if (newExpanded.has(rank)) {
      newExpanded.delete(rank)
    } else {
      newExpanded.add(rank)
    }
    setExpandedPersonas(newExpanded)
  }

  return (
    <div>
      {sortedPersonas.map((persona, index) => (
        <div key={persona.name}>
          <PersonaCard persona={persona} isExpanded={expandedPersonas.has(persona.rank)} onToggle={() => togglePersona(persona.rank)} />
          {index < sortedPersonas.length - 1 && <EuiSpacer size='m' />}
        </div>
      ))}
    </div>
  )
}

export default PersonaList
